module.exports = __webpack_public_path__ + "static/img/solution-2.836f462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution-2.png
// module id = BpLe
// module chunks = 0